import normalizeImageSrc from '../normalizeImageSrc';

const updateVariantImages = (container, selectedOptions, variantsData, optionNames) => {
  const optionInputEls = container?.querySelectorAll('input[data-variant-input]');
  if (!optionInputEls.length) return;
  const optionEls = [...new Set([...optionInputEls].map(i => i.name))];

  optionEls.forEach((optionName) => {
    const optionInput = container.querySelector(`input[name="${optionName}"]`);
    if (!optionInput) return;
    const optionContainerEl = optionInput.closest('li');
    if (!optionContainerEl) return;

    const optionLabelEls = optionContainerEl.querySelectorAll('[data-variant-label]');
    if (!optionLabelEls.length) return;

    optionLabelEls.forEach((label) => {
      const inputEl = label.control || container.querySelector(`#${label.htmlFor}`);
      if (!inputEl) return;

      const optionValue = inputEl.value;
      const currentOptions = { ...selectedOptions, [optionName]: optionValue };

      const matchingVariant = variantsData.find(variant =>
        optionNames.every((optionName, index) => {
          const selectedValue = currentOptions[optionName];
          const variantValue = variant[`option${index + 1}`];
          return String(selectedValue) === String(variantValue);
        })
      );

      if (!matchingVariant) return;

      const imageURL = matchingVariant.featured_image?.src;
      if (!imageURL) return;
      const formattedImageURL = normalizeImageSrc(imageURL);
      const imageEl = label.querySelector('[data-variant-image]');
      if (imageEl) {
        imageEl.setAttribute('src', formattedImageURL);
        if (imageEl.hasAttribute('srcset')) imageEl.setAttribute('srcset', formattedImageURL);
        if (matchingVariant.featured_image?.alt) imageEl.setAttribute('alt', matchingVariant.featured_image.alt);
      }
    });
  });
};

export default updateVariantImages;
